module.exports = __webpack_public_path__ + "assets/ic_chat_drapdown.8b7425c1.svg";